<template>
    <div class="car-patrol-view">
        <!-- 创建布控组件 -->
        <!-- start @description: 右侧创建布控面板!-->
        <ioc-drawer :width="460" :title="$t('carPatrol.button.create')"
                    :show-close="false"
                    v-model="dialogVisible"
                    :before-close="handleClose"
                    :custom-class="drawerControl"
                    :modal="false">
          <patrol-panel @submit="handleSubmit" ref="patrolPanel"></patrol-panel>
        </ioc-drawer>
        <!-- 布控摄像机组 -->
        <app-camers-group @change="carameChange" @cameraScatterPoint="cameraScatterPoint" :isRequired="true" ></app-camers-group>
        <!-- start @description: 引入IGIS地图 !-->
    </div>
</template>

<script>
import { api } from '../api'
import { Data,Dic } from "$utils";
export default {
  components: {
    // 摄像机组组件
    AppCamersGroup:() => import('@components/app-camera-group'),
    // 布控维护面板
    PatrolPanel:() => import('../components/PatrolPanel')
  },
  data() {
    return {
      igisMap: null,
      // 判断进入页面的标题
      // 默认抽屉关闭状态
      dialogVisible: false,
      modal: true,
      drawerControl: 'drawer-control',
      // 需要提交的数据
      formData:{
        bayonetList: [], // 摄像机组
        alarmLevel: '', // 布控等级
        groupList: [], // 布控名单组
        name: '', // 布控名称
        startDate: '', // 布控开始时间
        endDate: '', // 布控结束时间
        timeList: [] // 布控时间段
      },
      drawPoint: [], // 摄像机点位,
      scatteIconObj: null
    }
  },
  mounted() {
    this.dialogVisible = true;
  },
  methods: {
    /*
     *@name: 摄像机撒点
     *@param:{type} 
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-06-22 11:23:20
    */
    cameraScatterPoint (cameraArr) {
      let cameraArrPoint = []
      let _self = this
      _self.$nextTick(() => {
        _self.igisMap = _self.$refs.igis.map
        _self.scatteIconObj = new window.iGis.layers.IconLayer({
          gisMapObj: _self.igisMap,
          isRef: true,
          isHover: true,
          layerOptions: {
            isBox: false,
            anchor: [10, -10]
          }
        })
        cameraArr.forEach(item => {
          cameraArrPoint.push({
            src: 'images/map/resource/camera.png',
            label: item.deviceName,
            coord: [item.longitude,item.latitude]
          })
        })
        _self.scatteIconObj.setData(cameraArrPoint, 0);
      })
    },
    /*
     *@name:取消-返回到布控列表页面
     *@param:{type}
     *@description:返回到布控列表页面
     *@return:无
     *@author: zhengff
     *@date: 2019-05-02 22:06:00
    */
    handleClose() {
      this.$router.push({
        path: '/view/Index',
        name: 'carPatrol'
      })
    },
    inIndexPage(){
      this.$router.push({
        path: '/view/Index',
        name: 'carPatrol'
      })
    },
    /*
     *@name: 摄像机组回调事件
     *@param:{type} 
     *@description:
     *@return:
     *@author: zhengff
     *@date: 2019-05-08 23:17:12
    */
    carameChange(data = [], cameraArr = []){
      const bayonetList = []
      let filterArr = data.map(item => {
        return item.code
      })
      Array.from(new Set(filterArr)).forEach(item => {
        bayonetList.push({
          bayonetCode: item
        });
      })
      this.formData.bayonetList = bayonetList;
      this.igisMap = this.$refs.igis.map
      const _self = this
      this.iconObj && this.igisMap.removeLayer(this.iconObj)
      this.iconObj = new window.iGis.layers.IconLayer({
        gisMapObj: _self.igisMap,
        isRef: true,
        isHover: true,
        layerOptions: {
          isBox: false,
          anchor: [10, -10]
        }
      })
      _self.drawPoint.length = 0
      cameraArr.forEach(item => {
        _self.drawPoint.push({
          src: 'images/map/resource/camera_red.png',
          label: item.deviceName,
          coord: [item.longitude,item.latitude]
        })
      })
      this.iconObj.setData(_self.drawPoint, 0);
    },
    /*
     *@name:提交功能
     *@param:{type}
     *@description:
     *@return:
     *@author: zhengff
     *@date: 2019-04-30 18:04:39
    */
    handleSubmit() {
      if (!this.formData.bayonetList.length) {
        this.$message.warning('选择布控摄像机组')
        return false
      }
      let data = this.$refs['patrolPanel'].ruleForm
      let timeList = data.timeList
      let newTimeList = []
      let param = {
        name: data.controlName,
        startDate: data.startDate,
        endDate: data.endDate,
        alarmLevel: data.alarmLevel,
        // bayonetList: [{
        //   bayonetCode: "432f4f7e-d4bd-4f05-be2a-3f0b1df45ad8"
        // }],
        bayonetList: this.formData.bayonetList,
        groupList: data.groupList
      }
      for (let i in timeList) {
        let t = i
        timeList[i].forEach(item => {
          console.log(item)
          let startTime = item.startTime.split('')
          let endTime = item.endTime.split('')
          newTimeList.push({
            startTime: startTime[0] + startTime[1] + ':' + startTime[2] + startTime[3] + ':' + startTime[4] + startTime[5],
            endTime: endTime[0] + endTime[1] + ':' + endTime[2] + endTime[3] + ':' + endTime[4] + endTime[5],
            day: i
          })
        })
      }
      param.timeList = newTimeList
      this.$fetch(api.task.addVehicleTask, param).then(response => {
        if (!response.success) {
          this.$message.error(response.msgContent)
          return
        }
        this.$message.success('新增布控任务成功')
        this.inIndexPage()
      })
    }
  }
}
</script>
<style>
.car-patrol-view {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
